import * as React from "react";
import { cn } from "../lib/utils";

const LabelButton = React.forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => {
  return (
    <button
      className={cn(
        "bb-text-tiny text-gray-2 inline-flex items-center justify-center font-semibold whitespace-nowrap",
        "border-gray-1 box-border gap-2 rounded-md border-1 px-2 py-1",
        "transition-colors disabled:cursor-not-allowed",
        "tab-focus",
        "h-8",
        "hover:border-gray-2",
        className,
      )}
      ref={ref}
      {...props}
    />
  );
});
LabelButton.displayName = "LabelButton";

export { LabelButton };
